import $ from 'jquery'

import { showNotification } from './notificationHelper'

interface OrganizationIdsResponse {
	org_ids: string[]
}

export default function initPopulateOrganizationIntegrationIds(): void {
	$('#back-office-credential-id').change(function () {
		const populateOrganizationIntegrationIdsUrl = 'populate_organization_integration_ids'
		const backOfficeCredentialId = $('#back-office-credential-id').val()

		if (backOfficeCredentialId) {
			$.ajax({
				beforeSend: function (xhr) {
					xhr.setRequestHeader('X-CSRF-Token', $('meta[name="csrf-token"]').attr('content') as string)
				},
				data: { back_office_credential_id: backOfficeCredentialId },
				dataType: 'json',
				type: 'POST',
				url: populateOrganizationIntegrationIdsUrl,
			})
				.done(function (response: OrganizationIdsResponse) {
					const dataList = $('#org_ids')

					// First remove options from dropdown, otherwise options could potentially get repopulated several times, resulting in multiple duplicates
					dataList.find('option').remove()
					const organizationIntegrationIds = response.org_ids

					for (let i = 0; i < organizationIntegrationIds.length; i++) {
						$('<option />', {
							text: organizationIntegrationIds[i],
							value: organizationIntegrationIds[i],
						}).appendTo(dataList)
					}
				})
				.fail(function (response: JQuery.jqXHR) {
					const message = response.responseJSON?.error || 'An error occurred'

					showNotification(message, 'error')
				})
		}
	})
}
